
import axios from "axios";
import Constants from "../../../components.constants.js"
export default {
    namespaced: true,
    state() {
        return {
        };
    },
    actions: {
      async getFusionDataWithoutAuth(context){
            console.log(context);
            const headers = {
                'access-token': '9ea38a20-7b59-45b4-ba4d-a0437fccb72e',
            };              
            try{
                let resp = await axios.get(`${Constants.getDataWithoutAuthUrl}`, {headers});
                resp.data.statusCode = resp.status
                return resp.data;
            }catch(error){
                console.error(`[getFusionDataWithoutAuth][Store][Error occured while getting asset info--->${error}]`);
                return ""
            }
       }
    },
    getters: {
    },
    mutations: {
    },
};